<template>
    <v-row>
        <v-col
            cols="12"
            sm="8"
            md="6"
            lg="6"
            xl="4"
            offset-sm="2"
            offset-md="3"
            offset-lg="3"
            offset-xl="4"
            class="mt-4"
        >
            <v-card>
                <v-card-title class="text-center">
                    <h2>
                        Passwort vergessen
                        <br />
                        oder noch kein Passwort?
                    </h2>
                </v-card-title>
                <v-card-text>
                    <v-alert prominent class="mb-5">
                        <ul class="text-left mt-3 pl-5">
                            <li>
                                Um Ihr Passwort zu ändern, tragen Sie bitte Ihre E-Mail-Adresse ein
                                und senden das Formular ab.
                            </li>
                            <li>Sie bekommen dann eine E-Mail mit einem Link zugeschickt.</li>
                            <li>
                                Mit Hilfe dieses Links können Sie dann ein neues Passwort setzen.
                            </li>
                        </ul>
                    </v-alert>
                    <v-form novalidate @submit.stop.prevent>
                        <v-text-field
                            v-model="username"
                            :disabled="isLoading || isPasswordRequestedSuccessful"
                            prepend-inner-icon="mdi-email"
                            autofocus
                            type="text"
                            autocomplete="email"
                            placeholder="vorname.nachname@hs-anhalt.de"
                            name="username"
                            label="E-Mail-Adresse"
                            density="compact"
                            variant="outlined"
                        />
                        <v-alert v-if="usernameInvalidText && hasError" type="error" class="" closable>
                            {{ usernameInvalidText }}
                        </v-alert>
                        <v-text-field
                            id="fax"
                            v-model="honeypot"
                            type="text"
                            style="position: absolute; left: -10000px; top: -10000px"
                            placeholder="Faxnummer"
                            name="fax"
                            autocomplete="off"
                            aria-label="Fax"
                            aria-describedby="fax-help-block"
                        />
                        <v-btn
                            :disabled="isLoading || !validation || isPasswordRequestedSuccessful"
                            block
                            color="secondary"
                            type="submit"
                            :loading="isLoading"
                            class="mb-3"
                            @click="requestPasswordReset()"
                        >
                            Passwortänderung beantragen
                        </v-btn>
                        <common-general-error-alert
                            v-if="
                                hasError &&
                                !validationErrors().username &&
                                !validationErrors().global
                            "
                            class="mb-3"
                        />
                        <router-link class="btn btn-link" :to="{ name: 'Login' }">
                            Zurück zur Anmeldung
                        </router-link>
                    </v-form>
                    <v-alert
                        v-if="isPasswordRequestedSuccessful && !hasError"
                        prominent
                        type="success"
                        class="mt-3"
                    >
                        <p class="font-weight-bold">Herzlichen Glückwunsch!</p>
                        <p class="mb-0">
                            Sie sollten eine Mail bekommen haben.
                            <br />
                            Bitte schauen Sie ggfs. auch in ihrem Spam-Ordner nach.
                            <br />
                            Alle weiteren Schritte stehen in der Mail.
                        </p>
                    </v-alert>
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>
<script>
    'use strict'

    export default {
        name: 'PasswordReset',
        components: {},
        props: {
            usernameFromLogin: {
                required: false,
                type: String,
                default: ''
            }
        },
        data: () => ({
            username: '',
            usernameInvalidText: '',
            honeypot: '',
            state: null,
            isPasswordRequested: false,
            isPasswordRequestedSuccessful: false
        }),
        computed: {
            isLoading() {
                return this.$store.getters['security/isLoading']
            },
            hasError() {
                return this.$store.getters['security/hasError']
            },
            error() {
                return this.$store.getters['security/error']
            },
            validation() {
                if (this.username.trim().length <= 20) {
                    return null
                }

                return (
                    this.username.trim().endsWith('@hs-anhalt.de') ||
                    this.username.trim().endsWith('@projektmotor.de')
                )
            }
        },
        created() {
            if (this.usernameFromLogin) {
                this.username = this.usernameFromLogin
            }
            let redirect = this.$route.query.redirect

            if (this.$store.getters['security/isAuthenticated']) {
                if (typeof redirect !== 'undefined') {
                    this.$router.push({ path: redirect })
                } else {
                    this.$router.push({ name: 'ModulhandbuchPage' })
                }
            }
        },
        methods: {
            validationErrors() {
                const errors = {}
                if (!this.hasError) {
                    return errors
                }
                this.state = false
                const error = this.error
                if (error && error.data.violations) {
                    error.data.violations.forEach((violation) => {
                        const key = violation.propertyPath ? violation.propertyPath : 'global'
                        errors[key] = violation.message
                        this.usernameInvalidText = violation.message
                    })
                    return errors
                }
                if (error.data && error.data['hydra:description']) {
                    errors.global = error.data['hydra:description']
                    this.usernameInvalidText = errors.global
                }

                return errors
            },
            async requestPasswordReset() {
                this.isPasswordRequested = true
                await this.$store.dispatch('security/requestPasswordReset', {
                    email: this.username,
                    honeypot: this.honeypot
                })

                if (!this.hasError) {
                    this.isPasswordRequestedSuccessful = true
                }
            }
        }
    }
</script>

<style scoped></style>
